import {
  ADD_BULK_OPERATION,
  REMOVE_BULK_OPERATION,
  UPDATE_BULK_OPERATION_PROGRESS,
  CLEAR_BULK_OPERATIONS
} from '../actions/bulkOperationsActions';

import {
  RESET_ACCOUNT,
  LOG_OUT
} from '../actions/accountActions';

export const BULK_OPERATION_MAX_AGE_MS = 2 * 60 * 60 * 1000; // 2 hours

const isOperationStale = (op) => {
  const age = Date.now() - new Date(op.createdAt).getTime();
  return age > BULK_OPERATION_MAX_AGE_MS && (op.status === 'pending' || op.status === 'in_progress');
};

const initialState = {
  operations: [] // Array of bulk operations
};

export default function bulkOperationsReducer(state = initialState, action) {
  const { payload } = action;
  
  switch (action.type) {
    case ADD_BULK_OPERATION: {
      // Check if operation already exists to avoid duplicates
      const exists = state.operations.some(op => 
        op.teamUuid === payload.teamUuid && 
        op.workflowFileId === payload.workflowFileId
      );
      
      if (exists) {
        return state;
      }
      
      return {
        ...state,
        operations: [...state.operations, payload]
      };
    }

    case REMOVE_BULK_OPERATION: {
      return {
        ...state,
        operations: state.operations.filter(op => op.workflowFileId !== payload)
      };
    }

    case UPDATE_BULK_OPERATION_PROGRESS: {
      const { workflowFileId, progressData } = payload;
      
      return {
        ...state,
        operations: state.operations.map(op => {
          if (op.workflowFileId === workflowFileId) {
            return {
              ...op,
              ...progressData,
              status: progressData.status || op.status
            };
          }
          return op;
        })
      };
    }

    case CLEAR_BULK_OPERATIONS: {
      return {
        ...state,
        operations: []
      };
    }

    case 'persist/REHYDRATE': {
      const incoming = action.payload && action.payload.bulkOperations;
      if (!incoming) return state;

      const freshOperations = incoming.operations.filter(op => !isOperationStale(op));
      return { ...state, operations: freshOperations };
    }

    case RESET_ACCOUNT:
    case LOG_OUT: {
      return initialState;
    }

    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/redux/reducers/bulkOperationsReducer.js